import { API_BASE_URL, API_PATHS,getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class DiaryNoteService {

  
static getDiaryNote(item) {

  const user = JSON.parse(localStorage.getItem("user"));
  const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
         
 let api = `${API_BASE_URL}${dynamicPaths.getDiaryNote}`;
     const params = new URLSearchParams();
  
   if(item?.limit) params.append("limit", item.limit);
    if(item?.page) params.append("page", item.page);
      if(item?.id) params.append("id", item.id);
      if(item?.students) params.append("students",item.students);
    if(item?.teacherId) params.append("teacherId", item.teacherId);
    if ([...params].length > 0) {
    api += `?${params.toString()}`;
  }
    return axiosInstance
        .get(api,item)
}



static addDiaryNote(data) {
  const user = JSON.parse(localStorage.getItem("user"));
  const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
 let api = '';
     api = `${API_BASE_URL}${dynamicPaths.addDiaryNote}`;
     return axiosInstance
         .post(api,data)
}

static updateDiaryNote(data) {
  
   const user = JSON.parse(localStorage.getItem("user"));
  const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
 let api = '';
     api = `${API_BASE_URL}${dynamicPaths.editDiaryNote}`;
     return axiosInstance
         .put(api,data)
     
}
static deleteDiaryNote(id) {
   const user = JSON.parse(localStorage.getItem("user"));
  const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
 let api = '';
        api = `${API_BASE_URL}${dynamicPaths.deleteDiaryNote}?id=${id}`;
    
    return axiosInstance
        .delete(api)
}


}

export default DiaryNoteService;
